/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type UpdateCustomColorRefInput = {
    customColor: Array<Record<string, any>>;
    id: string;
    unitId?: string | null | undefined;
};
export type apiUpdateCustomColorRefMutationVariables = {
    input: UpdateCustomColorRefInput;
};
export type apiUpdateCustomColorRefMutationResponse = {
    readonly updateCustomColorRef: {
        readonly customColorRef: {
            readonly id: string;
            readonly customColor: ReadonlyArray<Record<string, any>>;
        };
    };
};
export type apiUpdateCustomColorRefMutation = {
    readonly response: apiUpdateCustomColorRefMutationResponse;
    readonly variables: apiUpdateCustomColorRefMutationVariables;
};



/*
mutation apiUpdateCustomColorRefMutation(
  $input: UpdateCustomColorRefInput!
) {
  updateCustomColorRef(input: $input) {
    customColorRef {
      id
      customColor
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateCustomColorRefPayload",
    "kind": "LinkedField",
    "name": "updateCustomColorRef",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CustomColorRef",
        "kind": "LinkedField",
        "name": "customColorRef",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "customColor",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "apiUpdateCustomColorRefMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "apiUpdateCustomColorRefMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b7f4980c5ff1242b34a5934a886a7fdc",
    "id": null,
    "metadata": {},
    "name": "apiUpdateCustomColorRefMutation",
    "operationKind": "mutation",
    "text": "mutation apiUpdateCustomColorRefMutation(\n  $input: UpdateCustomColorRefInput!\n) {\n  updateCustomColorRef(input: $input) {\n    customColorRef {\n      id\n      customColor\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '1a09143a187bf85b9aa036fabd68197e';
export default node;
